import { styled } from '@mui/material';

import getRawIconAsBase64 from '@webclient/lib/getRawIcon';

import { VoiceAssistantControlBar } from '@livekit/components-react';

const FULLY_ROUNDED_CORNER = 99999;

const StyledVoiceAssistantControlBar = styled(VoiceAssistantControlBar)(
  ({ theme }) => ({
    '.lk-button-group': {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row-reverse',
      height: theme.spacing(8.75),
      width: theme.spacing(17),
      alignItems: 'center',
      border: '1px solid',
      borderColor: theme.palette.border.primary,
      background: theme.palette.background.primary,
      borderRadius: theme.shape.borderRadius * FULLY_ROUNDED_CORNER,
      '& .lk-button[data-lk-source=microphone]': {
        width: theme.spacing(8),
        height: theme.spacing(8),
        borderRadius: '50%',
        cursor: 'pointer',
        background: theme.palette.utility.brand500,
        border: 'none',
        svg: {
          color: theme.palette.common.white,
        },
      },
      '& .lk-button.lk-button-menu': {
        '&::after': {
          content: `url(${getRawIconAsBase64('chev-up', theme.palette.utility.gray700, 18, 18)})`,
        },
        '&[aria-pressed="true"]': {
          transform: 'rotate(180deg)',
        },
        background: 'transparent',
        cursor: 'pointer',
        border: 'none',
        width: theme.spacing(8),
        height: theme.spacing(8),
      },
      'ul.lk-media-device-select.lk-list': {
        position: 'absolute',
        bottom: 50,
        left: 50,
        transform: 'translate(-50%, 0)',
        margin: 0,
        padding: 0,
        background: theme.palette.background.primary,
        borderRadius: theme.shape.borderRadius * 2,
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        '& li': {
          listStyleType: 'none',
          margin: theme.spacing(2.25, 4),
          "&[aria-selected='true'] .lk-button": {
            position: 'relative',
            '&::before': {
              background: 'white',
              boxShadow: `0px 0px 0px 3.6px ${theme.palette['Colors/Background/bg-brand-solid']} inset`,
            },
          },
          '& .lk-button': {
            ...theme.typography.textSm,
            cursor: 'pointer',
            color: theme.palette.text.quaternary,
            background: 'transparent',
            border: 'none',
            whiteSpace: 'pre',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            '::before': {
              marginRight: theme.spacing(2),
              content: '""',
              width: theme.spacing(4),
              height: theme.spacing(4),
              display: 'inline-block',
              background: theme.palette.background.primary,
              border: '1px solid',
              borderColor: theme.palette.foreground.quinary,
              borderRadius: '50%',
            },
          },
        },
      },
    },
  }),
);

export default StyledVoiceAssistantControlBar;
